let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2XbC1")).then(() => parcelRequire('eAmxO'));